/**
 * Prison Data Mapping
 * Maps prison names to their corresponding prison numbers
 */

const PRISON_DATA = {
  "Alaska - Goose Creek Correctional Center": "1824",
  "Alaska - Hiland Mountain Correctional Center": "1908",
  "Alaska - Lemon Creek Correctional Center": "2093",
  "Alaska - Mat-Su Pretrial Facility": "3278",
  "Alaska - Palmer Correctional Center": "3393",
  "Alaska - Point Mackenzie Correctional Farm": "3703",
  "Alaska - Spring Creek Correctional Center": "2763",
  "Alaska - Wildwood Correctional Center": "2984",
  "Alaska - Yukon Kuskokwim Correctional Center": "3070",
  "Alabama - Alabama Therapeutic Education Facility": "3363",
  "Alabama - Alexander City Work Release": "1019",
  "Alabama - Aliceville FCI": "1650",
  "Alabama - Bibb County Correctional Facility": "1185",
  "Alabama - Birmingham Community Based Facility/Community Work Center": "1194",
  "Alabama - Bullock  Correctional Facility": "1246",
  "Alabama - Camden Work Release Center": "1279",
  "Alabama - Childersburg Work Release Center": "1376",
  "Alabama - Easterling Correctional Facility": "1586",
  "Alabama - Elba Community Work Center": "1610",
  "Alabama - Elmore Correctional Facility": "1617",
  "Alabama - Etowah County Detention Center": "3592",
  "Alabama - Fountain Correctional Facility": "1759",
  "Alabama - Frank Lee Correctional Facility": "1775",
  "Alabama - Hamilton Aged and Infirmed Correctional Facility": "1866",
  "Alabama - Holman Correctional Facility": "1922",
  "Alabama - Julia Tutwiler Prison For Women": "2015",
  "Alabama - Kilby Correctional Facility": "2039",
  "Alabama - Limestone Correctional Facility": "2103",
  "Alabama - Loxley Work Release Center": "2138",
  "Alabama - Mobile Work Release Center": "2304",
  "Alabama - Montgomery FPC": "2213",
  "Alabama - Montgomery Women's Facility": "2316",
  "Alabama - North Alabama Community Based Facility &amp;amp; Work Center": "1520",
  "Alabama - Red Eagle Work Center": "2562",
  "Alabama - Saint Clair Correctional Facility": "2634",
  "Alabama - Staton Correctional Facility": "2774",
  "Alabama - Talladega FCI": "1696",
  "Alabama - Ventress Correctional Facility": "2893",
  "Alabama - William E. Donaldson Correctional Facility": "2991",
  "Arkansas - ADC Mississippi Co. Work Release Center": "1007",
  "Arkansas - Barbara Ester Unit": "1628",
  "Arkansas - Benton Work Release Unit": "1176",
  "Arkansas - Cummins Unit": "1488",
  "Arkansas - Delta Regional Unit": "1530",
  "Arkansas - East Arkansas Regional Unit (EARU)": "1578",
  "Arkansas - East Central Arkansas Community Correction Center": "2742",
  "Arkansas - Forrest City Low FCI": "1750",
  "Arkansas - Forrest City Medium FCI": "1749",
  "Arkansas - Hawkins Center For Women": "1885",
  "Arkansas - Hawkins Unit (Men)": "1884",
  "Arkansas - Hempstead County Detention Center": "3508",
  "Arkansas - Larry B Norris Unit": "2212",
  "Arkansas - McPherson Unit": "2249",
  "Arkansas - North Central Unit": "2371",
  "Arkansas - Northeast Arkansas Community Correction Center": "2382",
  "Arkansas - Northwest Arkansas Community Correction": "2400",
  "Arkansas - Ouachita River Correctional Unit": "2458",
  "Arkansas - Pine Bluff Complex": "2496",
  "Arkansas - Randall L Williams Correctional Facility": "2555",
  "Arkansas - Scott Grimes Correctional Facility": "1851",
  "Arkansas - Sebastian County Adult Detention Center": "3486",
  "Arkansas - Southwest Arkansas Community Correction Center": "2756",
  "Arkansas - Texarkana Regional Correction Center": "1008",
  "Arkansas - Tucker Unit": "2853",
  "Arkansas - Varner Unit": "2892",
  "Arkansas - Wrightsville Unit And Boot Camp": "3014",
  "Arizona - ASP Central Arizona Correctional Facility": "1049",
  "Arizona - ASP Florence West": "1050",
  "Arizona - ASP Kingman": "1051",
  "Arizona - ASP Phoenix West Correctional and Rehabilitation Facility": "1054",
  "Arizona - ASPC Douglas": "1055",
  "Arizona - ASPC Eyman": "1062",
  "Arizona - ASPC Florence - South Unit": "1076",
  "Arizona - ASPC Lewis": "1077",
  "Arizona - ASPC Perryville": "1084",
  "Arizona - ASPC Phoenix": "1091",
  "Arizona - ASPC Safford": "1096",
  "Arizona - ASPC Tucson": "1100",
  "Arizona - ASPC Winslow": "1111",
  "Arizona - ASPC Winslow - Apache Unit": "1112",
  "Arizona - ASPC Yuma": "1115",
  "Arizona - Central Arizona Florence Correctional Complex": "1317",
  "Arizona - La Palma Correctional Center": "1318",
  "Arizona - Mohave County Adult Detention Facility": "2305",
  "Arizona - Phoenix FCI": "1690",
  "Arizona - Red Rock Correctional Center": "1320",
  "Arizona - Safford FCI": "1691",
  "Arizona - Saguaro Correctional Center": "1321",
  "Arizona - San Luis Regional Detention and Support Center": "3367",
  "Arizona - Tucson FCC": "1647",
  "California - Adelanto ICE Processing Center": "1009",
  "California - Atwater USP": "2875",
  "California - Avenal State Prison": "1133",
  "California - Blythe Jail": "1206",
  "California - Butte County Jail": "3276",
  "California - California Correctional Institution - Tehachapi": "1267",
  "California - California Health Care Facility": "1268",
  "California - California Institution for Men": "1385",
  "California - California Institution for Women": "1387",
  "California - California Medical Facility": "1269",
  "California - California Men's Colony": "1270",
  "California - California Rehabilitation Center": "1271",
  "California - California State Prison Corcoran": "1272",
  "California - California State Prison Sacramento": "1273",
  "California - California State Prison Solano": "1274",
  "California - California State Prison-LA County-Lancaster": "1275",
  "California - California Substance Abuse Treatment Facility": "1276",
  "California - Calipatria State Prison": "1277",
  "California - Camp Pendleton Security Battalion": "1292",
  "California - Casa Aurora Rehabilitative Center": "3081",
  "California - Centinela State Prison": "1329",
  "California - Central California Women's Facility": "1332",
  "California - Century Regional Detention Facility": "1355",
  "California - Cois Byrd Detention Center": "2758",
  "California - Correctional Training Facility": "1469",
  "California - Custody to Community Transitional Re-Entry Program": "3247",
  "California - East Mesa Re-Entry Facility": "1582",
  "California - El Centro Detention Facility": "3656",
  "California - Elmwood Correctional Facility": "1618",
  "California - Folsom State Prison": "2434",
  "California - George Bailey Detention Facility": "1809",
  "California - Herlong FCI": "1669",
  "California - High Desert State Prison": "1902",
  "California - Ironwood State Prison": "1971",
  "California - John Benoit Detention Center": "2598",
  "California - Kern County Detention Center-Lerdo": "2034",
  "California - Kern Valley State Prison": "2036",
  "California - Las Colinas Detention and Reentry Center": "2076",
  "California - Lompoc FCC": "1671",
  "California - Los Angeles MDC": "2269",
  "California - Madera County Sheriff's Office- Jail division": "2155",
  "California - Malibu Conservation Camp #13": "2166",
  "California - Marin County Sheriff's Office": "3385",
  "California - Mendota FCI": "1682",
  "California - Miramar Naval Consolidated Brig": "2296",
  "California - Mule Creek State Prison": "2332",
  "California - North Kern State Prison": "2377",
  "California - Otay Mesa Detention Center": "2454",
  "California - Parlin Fork Conservation Camp": "2468",
  "California - Pelican Bay State Prison": "2476",
  "California - Pleasant Valley State Prison": "2508",
  "California - Prototypes Women's Center": "2533",
  "California - Puerta La Cruz Conservation Camp": "2536",
  "California - R.J. Donovan Correctional Facility": "2546",
  "California - Rio Cosumnes Correctional Center": "2588",
  "California - Robert Presley Detention Center": "2604",
  "California - Sacramento County Main Jail": "2626",
  "California - Salinas Valley State Prison": "2642",
  "California - San Diego Central Jail": "2645",
  "California - San Diego MCC": "2267",
  "California - San Francisco County Jails": "3266",
  "California - San Joaquin Sheriff's Office": "3346",
  "California - San Mateo Jails": "3267",
  "California - San Quentin State Prison": "2648",
  "California - Santa Ana City Jail": "2654",
  "California - Santa Rita Jail - Alameda County": "1014",
  "California - Sierra Conservation Center": "2710",
  "California - Smith Correctional Facility": "2716",
  "California - South Bay Detention Center": "3269",
  "California - Terminal Island FCI": "1698",
  "California - Valley State Prison": "2889",
  "California - Victorville FCC": "2872",
  "California - Vista Detention Facility": "2902",
  "California - Wasco State Prison": "2927",
  "California - WestCare": "3281",
  "California - Western Region Detention Facility": "2975",
  "Colorado - Adams County Detention Facility": "1003",
  "Colorado - Arkansas Valley Correctional Facility": "1045",
  "Colorado - Bent County Correctional Facility": "1175",
  "Colorado - Buena Vista Correctional Complex": "1243",
  "Colorado - Centennial Correctional Facility": "1326",
  "Colorado - CMC/Arrowhead Correctional Center": "1415",
  "Colorado - CMC/Four Mile Correctional Center": "1416",
  "Colorado - Colorado Justice Center": "1435",
  "Colorado - Colorado State Penitentiary": "1436",
  "Colorado - Colorado Territorial Correctional Facility": "1437",
  "Colorado - Crowley County Correctional Facility": "1486",
  "Colorado - Delta Correctional Center": "1528",
  "Colorado - Denver County Jail": "1534",
  "Colorado - Denver Downtown Detention Center": "1535",
  "Colorado - Denver Reception and Diagnostic Center": "1536",
  "Colorado - Denver Women's Correctional Facility": "1537",
  "Colorado - Englewood FCI": "1662",
  "Colorado - Florence ADMAX USP": "1643",
  "Colorado - Florence FCI": "1665",
  "Colorado - Florence High USP": "2880",
  "Colorado - Fremont Correctional Facility": "1789",
  "Colorado - La Vista Correctional Facility": "2051",
  "Colorado - Limon Correctional Facility": "2104",
  "Colorado - Mesa County Detention Facility": "2259",
  "Colorado - Mount View Youth Services Center": "2327",
  "Colorado - Pueblo County Sheriff's Office": "2535",
  "Colorado - Rifle Correctional Center": "2587",
  "Colorado - San Carlos Correctional Facility": "2644",
  "Colorado - Skyline Correctional Center": "3543",
  "Colorado - Sterling Correctional Facility": "2775",
  "Colorado - Trinidad Correctional Facility": "2850",
  "Colorado - Weld County Jail": "2956",
  "Connecticut - Bridgeport Correctional Center": "1221",
  "Connecticut - Brooklyn Correctional Institution": "1230",
  "Connecticut - Carl Robinson CI": "1300",
  "Connecticut - Cheshire Correctional Institution": "1372",
  "Connecticut - Corrigan Correctional Center": "1471",
  "Connecticut - Danbury FCI": "1504",
  "Connecticut - Garner CI - Religious Services": "1801",
  "Connecticut - Hartford Correctional Center": "3151",
  "Connecticut - MacDougall-Walker CI": "2149",
  "Connecticut - Osborn Correctional Institution": "2452",
  "Connecticut - Radgowski Correctional Institution": "2550",
  "Connecticut - Walker Reception Center": "2911",
  "Connecticut - Willard-Cybulski CI Religious Services": "2989",
  "Connecticut - York Correctional Institution": "3028",
  "Delaware - Baylor Women's Correctional Institution": "1494",
  "Delaware - Hazel D. Plant Women's Treatment Facility": "1891",
  "Delaware - Howard R. Young Correctional Institution": "1932",
  "Delaware - James T. Vaughn Correctional Center": "1988",
  "Delaware - Kent Community Corrections Treatment Center": "3110",
  "Delaware - Plummer Community Corrections Center": "2509",
  "Delaware - Sussex Correctional Institution": "2795",
  "Florida - Apalachee Correctional Institution East": "1040",
  "Florida - Apalachee Correctional Institution West": "1041",
  "Florida - Avon Park Correctional Institution": "1135",
  "Florida - Baker Re-Entry Center": "1143",
  "Florida - Bay Correctional Facility": "1158",
  "Florida - Blackwater River Correctional and Rehabilitation Facility": "1200",
  "Florida - Bradenton Bridge TC Work Release": "1216",
  "Florida - Bridges of Santa Fe Work Release Center": "2657",
  "Florida - Calhoun Correctional Institution": "1262",
  "Florida - Central Florida Reception Center East": "1334",
  "Florida - Central Florida Reception Center Main": "1335",
  "Florida - Central Florida Reception Center South": "1336",
  "Florida - Century Correctional Institution": "1354",
  "Florida - Charlotte Correctional Institution": "1366",
  "Florida - Citrus County Detention Facility": "3349",
  "Florida - Coleman I USP": "2878",
  "Florida - Coleman II USP": "2879",
  "Florida - Coleman Low FCI": "1641",
  "Florida - Coleman Medium FCI": "1642",
  "Florida - Columbia Correctional Institution": "1439",
  "Florida - Columbia Correctional Institution Annex": "1441",
  "Florida - Cross City Correctional Institution": "1481",
  "Florida - Cross City East Unit": "3453",
  "Florida - Cross City Work Camp": "1482",
  "Florida - Dade Correctional Institution": "1495",
  "Florida - Daytona Beach Community Correction Center": "1517",
  "Florida - Desoto Correctional Institution Annex": "1540",
  "Florida - Desoto Work Camp": "1542",
  "Florida - Everglades Correctional Institution": "1632",
  "Florida - Everglades Re-Entry center": "3487",
  "Florida - Florida Civil Commitment Center": "3560",
  "Florida - Florida State Prison": "1734",
  "Florida - Florida Womens Reception Center": "1736",
  "Florida - Franklin Correctional Institution": "1779",
  "Florida - Gadsden Correctional Facility": "1796",
  "Florida - Gadsden Reentry Center": "1797",
  "Florida - Graceville Correctional Facility": "1829",
  "Florida - Gulf Correctional Institution": "1856",
  "Florida - Hamilton Correctional Institution ANNEX": "1867",
  "Florida - Hamilton Correctional Institution Main Unit": "1868",
  "Florida - Hardee Correctional Institution": "1874",
  "Florida - Hernando Correctional Institution": "1900",
  "Florida - Hollywood Work Release Center": "1921",
  "Florida - Holmes Correctional Institution": "1923",
  "Florida - Homestead Correctional Institution": "1926",
  "Florida - Jackson Correctional Institution": "1978",
  "Florida - Jacksonville Bridge Community Release Center": "1981",
  "Florida - Jefferson Correctional Institution": "1993",
  "Florida - Kissimmee Work Release Center": "2043",
  "Florida - Lake City Correctional Facility": "2054",
  "Florida - Lake Correctional Institution": "2056",
  "Florida - Lancaster Correctional Institution": "2063",
  "Florida - Lawtey Correctional Institution": "2079",
  "Florida - Liberty Correctional Institution": "2098",
  "Florida - Lowell Correctional Institution ANNEX": "2131",
  "Florida - Lowell Correctional Institution Main": "2132",
  "Florida - Madison Correctional Institution": "2159",
  "Florida - Marianna FCI": "1675",
  "Florida - Marion Correctional Institution": "2181",
  "Florida - Martin Correctional Institution": "2193",
  "Florida - Mayo Correctional Institution Annex": "2214",
  "Florida - Miami FCI": "1684",
  "Florida - Miami FDC": "1707",
  "Florida - Moore Haven Correctional Facility": "2317",
  "Florida - North Florida Evaluation and Treatment Center": "3485",
  "Florida - Northwest Florida Reception Center": "2404",
  "Florida - Northwest Florida Reception Center Annex": "2405",
  "Florida - Okaloosa Correctional Institution": "2426",
  "Florida - Okeechobee Correctional Institution": "2428",
  "Florida - Orlando Work Release Center": "2449",
  "Florida - Panama City Community Release Center": "2467",
  "Florida - Pensacola FPC": "1771",
  "Florida - Pinellas County Jail": "3198",
  "Florida - Polk Correctional Institution": "2512",
  "Florida - Putnam Correctional Institution": "2541",
  "Florida - Reception and Medical Center Main": "2559",
  "Florida - Reception and Medical Center West": "2560",
  "Florida - Riverside House": "3386",
  "Florida - Sago Palm Re-Entry Center / Work Camp": "2630",
  "Florida - Santa Rosa Correctional Institution": "2658",
  "Florida - Santa Rosa Correctional Institution Annex": "2659",
  "Florida - South Bay Correctional Facility": "2721",
  "Florida - South Florida Reception Center Main": "2731",
  "Florida - St. Johns County Sheriff's Office": "3606",
  "Florida - Sumter Correctional Institution": "2792",
  "Florida - Suwannee Correctional Institution": "2801",
  "Florida - Suwannee Correctional Institution Annex": "2802",
  "Florida - Tallahassee FCI": "1697",
  "Florida - Taylor Correctional Institution": "2813",
  "Florida - Tomoka Correctional Institution": "2837",
  "Florida - Union Correctional Institution": "2868",
  "Florida - Wakulla Correctional Institution": "2906",
  "Florida - Wakulla Correctional Institution Annex": "2907",
  "Florida - Walton Correctional Institution": "2918",
  "Florida - Walton County Jail": "3449",
  "Florida - Zephyrhills Correctional Institution": "3034",
  "Georgia - Atlanta FCI": "2871",
  "Georgia - Atlanta Transitional Center": "1119",
  "Georgia - Augusta State Medical Prison": "1129",
  "Georgia - Autry State Prison": "1131",
  "Georgia - Baldwin State Prison": "1145",
  "Georgia - Buruss Correctional Training Center": "1251",
  "Georgia - Calhoun State Prison": "1263",
  "Georgia - Central State Prison": "1346",
  "Georgia - Charles D Hudson Transitional Center": "1361",
  "Georgia - Clayton Transitional Center": "1392",
  "Georgia - Coastal State Prison": "1419",
  "Georgia - Coffee Correctional Institution": "1423",
  "Georgia - Dodge State Prison": "1556",
  "Georgia - Dooly State Prison": "1559",
  "Georgia - Effingham County Correctional Inst.": "1604",
  "Georgia - Emanuel Womens Facility": "1621",
  "Georgia - Georgia Diagnostic and Classification Center": "1812",
  "Georgia - Hall County Correctional Institution": "3372",
  "Georgia - Hancock State Prison": "1873",
  "Georgia - Hays State Prison": "1889",
  "Georgia - Helms Medical Center": "1893",
  "Georgia - Jenkins Correctional Facility": "3232",
  "Georgia - Jesup FCI": "1670",
  "Georgia - Johnson State Prison": "2010",
  "Georgia - Lee Arrendale State Prison": "1046",
  "Georgia - Lee State Prison": "2091",
  "Georgia - Long State Prison": "2120",
  "Georgia - Macon State Prison": "2154",
  "Georgia - McRae Women's Facility": "2250",
  "Georgia - Metro Reentry Facility": "2262",
  "Georgia - Metro Transitional Center": "2263",
  "Georgia - Montgomery State Prison": "2315",
  "Georgia - Muscogee County Prison": "3482",
  "Georgia - Phillips State Prison": "2489",
  "Georgia - Probation Substance Abuse Treatment Center": "3457",
  "Georgia - Pulaski State Prison": "2539",
  "Georgia - Richmond County Correctional (Camp)": "2583",
  "Georgia - Riverbend Correctional Facility": "2592",
  "Georgia - Robert A Deyton Detention Facility ICE": "3244",
  "Georgia - Rogers State Prison": "2612",
  "Georgia - Rutledge State Prison": "2625",
  "Georgia - Smith State Prison": "2717",
  "Georgia - Spalding County Correctional Institution": "2761",
  "Georgia - Telfair State Prison": "2819",
  "Georgia - Valdosta State Prison": "2888",
  "Georgia - Walker State Prison": "2912",
  "Georgia - Ware State Prison": "2920",
  "Georgia - Washington State Prison": "2940",
  "Georgia - West Central Integrated Treatment Facility": "2959",
  "Georgia - Wheeler Correctional Facility": "2979",
  "Georgia - Whitworth Women's Facility": "2982",
  "Georgia - Wilcox State Prison": "2983",
  "Georgia - Women's Probation Detention Center": "3694",
  "Hawaii - Habilitat, Inc.": "3351",
  "Hawaii - Halawa Correctional Facility": "1862",
  "Hawaii - Honolulu FDC": "1706",
  "Hawaii - Kauai Community Correctional Center": "2025",
  "Hawaii - Kulani Correctional Facility": "2047",
  "Hawaii - Maui Community Correctional Center": "2209",
  "Hawaii - Oahu Community Correctional Center": "2414",
  "Hawaii - Waiawa Correctional Facility": "2904",
  "Hawaii - Women's Community Correctional Center": "3004",
  "Iowa - Anamosa State Penitentiary": "1035",
  "Iowa - Clarinda Correctional Facility": "1390",
  "Iowa - Fort Dodge Correctional Facility": "1754",
  "Iowa - Iowa Correctional Institution for Women": "1968",
  "Iowa - Iowa Medical and Classification Center": "1969",
  "Iowa - Iowa State Penitentiary": "1970",
  "Iowa - Mount Pleasant Correctional Facility": "2326",
  "Iowa - Newton Correctional Facility": "2360",
  "Iowa - North Central Correctional Facility": "2369",
  "Idaho - East Boise Community Reentry Center": "1579",
  "Idaho - Idaho Correctional Institution - Orofino": "1946",
  "Idaho - Idaho Maximum Security Institution": "1948",
  "Idaho - Idaho State Correctional Center": "1949",
  "Idaho - Idaho State Correctional Institution": "1950",
  "Idaho - Mountain View Transformation Center": "3612",
  "Idaho - Nampa Community Work Center": "2338",
  "Idaho - North Idaho Correctional Institution": "2376",
  "Idaho - Pocatello Women's Correctional Center": "2511",
  "Idaho - Saint Anthony Work Camp": "2631",
  "Idaho - South Boise Women's Correctional Center": "2723",
  "Idaho - South Idaho Correctional Institution": "2733",
  "Idaho - South Idaho Correctional Institution Pre-Release Center": "2734",
  "Illinois - Big Muddy River Correctional Center": "1186",
  "Illinois - Centralia Correctional Center": "1352",
  "Illinois - Champaign County Jail": "3729",
  "Illinois - Chicago MCC": "2265",
  "Illinois - Cook County Jail": "1461",
  "Illinois - Crossroads Adult Transition Center": "1483",
  "Illinois - Danville Correctional Center": "1507",
  "Illinois - Decatur Correctional Center": "1518",
  "Illinois - Dixon Correctional Center": "1553",
  "Illinois - East Moline Correctional Center": "1584",
  "Illinois - Fox Valley Adult Transition Center": "1762",
  "Illinois - Graham Correctional Center": "1833",
  "Illinois - Greenville FCI": "1649",
  "Illinois - Hill Correctional Center": "1909",
  "Illinois - Illinois River Correctional Center": "1951",
  "Illinois - Jacksonville Correctional Center": "1982",
  "Illinois - Joliet Treatment Center": "3248",
  "Illinois - Kewanee Life Skills Re-entry Center": "3067",
  "Illinois - Lawrence Correctional Center": "2077",
  "Illinois - Lincoln Correctional Center": "2105",
  "Illinois - Logan Correctional Center": "2117",
  "Illinois - Marion FCI": "2186",
  "Illinois - Menard Correctional Center": "2255",
  "Illinois - Murphysboro Life Skills Re-Entry Center": "3252",
  "Illinois - North Lawndale Adult Transition Center": "2379",
  "Illinois - Northern Reception and Classification Unit": "2396",
  "Illinois - Pekin FCI": "1689",
  "Illinois - Pinckneyville Correctional Center": "2495",
  "Illinois - Pittsfield Work Camp": "3066",
  "Illinois - Pontiac Correctional Center": "2520",
  "Illinois - Robinson Correctional Center": "2607",
  "Illinois - Shawnee Correctional Center": "2703",
  "Illinois - Sheridan Correctional Center": "2707",
  "Illinois - Southwestern Illinois Correctional Center": "2759",
  "Illinois - Taylorville Correctional Center": "2816",
  "Illinois - Thomson FCI": "1130",
  "Illinois - Vandalia Correctional Center": "2891",
  "Illinois - Vienna Correctional Center": "2898",
  "Illinois - Western Illinois Correctional Center": "2970",
  "Illinois - Winnebago County Jail": "3397",
  "Indiana - Branchville Correctional Facility": "1218",
  "Indiana - Chain O' Lakes Correctional Facility": "1357",
  "Indiana - Correctional Industrial Facility": "1466",
  "Indiana - Edinburgh Correctional Facility": "1600",
  "Indiana - Heritage Trail Correctional Facility": "1899",
  "Indiana - Indiana State Prison": "1956",
  "Indiana - Indiana State Prison - ISO": "1957",
  "Indiana - Indiana Womens Prison": "1958",
  "Indiana - Kosciusko County Jail": "2046",
  "Indiana - La Porte County Jail": "3364",
  "Indiana - Logansport Juvenile Correctional": "3439",
  "Indiana - Madison Correctional Facility": "2158",
  "Indiana - Miami Correctional Facility Phase II": "2275",
  "Indiana - New Castle Correctional Facility": "2349",
  "Indiana - Pendleton Correctional Facility": "2478",
  "Indiana - Plainfield Correctional Facility": "2506",
  "Indiana - Putnamville Correctional Facility": "2542",
  "Indiana - Rockville Correctional Facility": "2610",
  "Indiana - South Bend Community Re-entry Center": "2722",
  "Indiana - Terre Haute FCC": "1646",
  "Indiana - Wabash Valley Correctional Facility": "2903",
  "Indiana - Westville Correctional Facility": "2978",
  "Kansas - El Dorado Correctional Facility": "1606",
  "Kansas - El Dorado Correctional Facility - Southeast Medium Unit": "3361",
  "Kansas - Ellsworth Correctional Facility": "1614",
  "Kansas - Hutchinson Correctional Facility": "1941",
  "Kansas - Kansas Juvenile Correctional Complex": "2022",
  "Kansas - Lansing Correctional Facility": "2070",
  "Kansas - Larned State Correctional Facility": "2074",
  "Kansas - Leavenworth FCI": "2881",
  "Kansas - Norton Correctional Facility": "2409",
  "Kansas - Stockton Correctional Facility": "2782",
  "Kansas - Topeka Correctional Facility": "2839",
  "Kansas - United States Disciplinary Barracks": "2870",
  "Kansas - Winfield Correctional Facility": "2995",
  "Kentucky - Ashland FCI": "1653",
  "Kentucky - Bell County Forestry Camp": "1171",
  "Kentucky - Big Sandy USP": "2876",
  "Kentucky - Blackburn Correctional Complex": "1198",
  "Kentucky - Bullitt County Detention Center": "3368",
  "Kentucky - Dismas Charities Portland": "1552",
  "Kentucky - Eastern Kentucky Correctional Complex": "1591",
  "Kentucky - Eastern Regional Jail and Correctional Facility": "2705",
  "Kentucky - Fulton County Detention Center": "3353",
  "Kentucky - Green River Correctional Complex": "1842",
  "Kentucky - Kentucky Correctional Institution for Women": "2031",
  "Kentucky - Kentucky State Penitentiary": "2032",
  "Kentucky - Kentucky State Reformatory": "2033",
  "Kentucky - Laurel County Correctional Facility": "3724",
  "Kentucky - Lee Adjustment Center": "3215",
  "Kentucky - Lexington FMC": "1741",
  "Kentucky - Little Sandy Correctional Complex": "2111",
  "Kentucky - Luther Luckett Correctional Complex": "2142",
  "Kentucky - Manchester FCI": "1673",
  "Kentucky - Marshall County Detention Center": "3683",
  "Kentucky - McCreary USP": "2885",
  "Kentucky - Northpoint Training Center": "2399",
  "Kentucky - Roederer Correctional Complex": "2611",
  "Kentucky - Southeast State Correctional Complex": "3432",
  "Kentucky - Western Kentucky Correctional Complex": "2971",
  "Louisiana - Allen Correctional Center": "1024",
  "Louisiana - B.B. Rayburn Correctional Center": "1140",
  "Louisiana - Calcasieu Correctional Center": "1258",
  "Louisiana - Caldwell Correctional Center - LA": "1260",
  "Louisiana - Catahoula Correctional Center": "3456",
  "Louisiana - Concordia Parish Correctional Facility": "3450",
  "Louisiana - David Wade Correctional Center": "1510",
  "Louisiana - Dixon Correctional Institute": "1554",
  "Louisiana - East Baton Rouge Parish Prison": "3623",
  "Louisiana - Elayn Hunt Correctional Center": "1609",
  "Louisiana - Franklin Parish Detention Center": "1784",
  "Louisiana - Grant Parish Detention Center": "3452",
  "Louisiana - Louisiana Correctional Institute for Women": "3063",
  "Louisiana - Louisiana State Penitentiary": "2127",
  "Louisiana - Louisiana Transitional Center for Women": "2128",
  "Louisiana - Oakdale FCC": "1687",
  "Louisiana - Pollock FCI": "2886",
  "Louisiana - Pollock USP": "1645",
  "Louisiana - Raymond Laborde Correctional Center": "1138",
  "Louisiana - Richwood Correctional Facility": "2584",
  "Louisiana - South Louisiana ICE Processing Center (SLIPC)": "3655",
  "Louisiana - Tensas Parish Detention Center": "3203",
  "Massachusetts - Boston Pre Release Center": "1212",
  "Massachusetts - Bridgewater State Hospital": "1225",
  "Massachusetts - Bristol County House of Correction": "1227",
  "Massachusetts - Devens FMC": "1718",
  "Massachusetts - Franklin County House of Correction": "1780",
  "Massachusetts - Massachusetts Treatment Center": "2208",
  "Massachusetts - MCI Cedar Junction": "2241",
  "Massachusetts - MCI Concord": "2242",
  "Massachusetts - MCI Framingham": "2243",
  "Massachusetts - MCI Norfolk": "2244",
  "Massachusetts - MCI Shirley": "2245",
  "Massachusetts - Middleton House of Correction": "3561",
  "Massachusetts - North Central Correctional Institution": "2370",
  "Massachusetts - Northeastern Correctional Center": "2390",
  "Massachusetts - Old Colony Correctional Center": "2433",
  "Massachusetts - Pondville Correctional Center": "2519",
  "Massachusetts - South Middlesex Correctional Center": "2736",
  "Massachusetts - Souza-Baranowski Correctional Center": "2760",
  "Massachusetts - Suffolk County HOC": "2787",
  "Maryland - Baltimore City Correctional Center": "1146",
  "Maryland - Carroll County Detention Center": "3409",
  "Maryland - Central Maryland Correctional Facility": "1337",
  "Maryland - Chesapeake Detention Facility": "1371",
  "Maryland - Cumberland FCI": "1648",
  "Maryland - Dorsey Run Correctional Facility": "1560",
  "Maryland - Eastern Correctional Institution - Annex": "1588",
  "Maryland - Eastern Correctional Institution - East and West": "1589",
  "Maryland - Jessup Correctional Institution": "2000",
  "Maryland - Maryland Correctional Institution - Hagerstown": "2199",
  "Maryland - Maryland Correctional Institution - Jessup": "2200",
  "Maryland - Maryland Correctional Institution for Women": "2201",
  "Maryland - Maryland Correctional Training Center": "2202",
  "Maryland - Maryland Reception - Diagnostic and Classification Center": "2204",
  "Maryland - Montgomery County Correctional Facility": "2312",
  "Maryland - North Branch Correctional Institution": "2366",
  "Maryland - Patuxent Institution": "2475",
  "Maryland - Pre-Release Center Rockville": "3695",
  "Maryland - Roxbury Correctional Institution": "2618",
  "Maryland - Western Correctional Institution": "2969",
  "Maine - Bolduc Correctional Facility": "1207",
  "Maine - Maine Correctional Center (Men)": "2164",
  "Maine - Maine Correctional Women's Center": "3435",
  "Maine - Maine State Prison": "2165",
  "Maine - Mountain View Correctional Facility": "2328",
  "Maine - Southern Maine Women's Reentry Center": "3376",
  "Michigan - Alger Correctional Facility": "1021",
  "Michigan - Baraga Maximum Correctional Facility": "1148",
  "Michigan - Bellamy Creek Correctional Facility": "1172",
  "Michigan - Carson City Correctional Facility West": "1305",
  "Michigan - Central Michigan Correctional Facility": "1338",
  "Michigan - Chippewa Correctional Facility": "1379",
  "Michigan - Cooper Street Correctional Facility": "1463",
  "Michigan - Earnest C Brooks Correctional Facility": "1577",
  "Michigan - Egeler Reception Center": "1605",
  "Michigan - G Robert Cotton Correctional Facility": "1795",
  "Michigan - Gus Harrison Correctional Facility": "1860",
  "Michigan - Ionia Maximum Correctional Facility": "1967",
  "Michigan - Kent County Jail": "3415",
  "Michigan - Kinross Correctional Facility": "2040",
  "Michigan - Lakeland Correctional Facility": "2058",
  "Michigan - Macomb Correctional Facility": "2152",
  "Michigan - Macomb County Jail": "2153",
  "Michigan - Marquette Branch Prison": "2190",
  "Michigan - Milan FCI": "1685",
  "Michigan - Muskegon Correctional Facility": "2335",
  "Michigan - Newberry Correctional Facility": "2359",
  "Michigan - Oaks Correctional Facility": "2417",
  "Michigan - Parnall Correctional Facility": "2469",
  "Michigan - Richard A Handlon Correctional Facility": "2580",
  "Michigan - Saginaw Correctional Facility": "2628",
  "Michigan - Saint Clair County Jail": "3455",
  "Michigan - Saint Louis Correctional Facility": "2637",
  "Michigan - Thumb Correctional Facility": "2832",
  "Michigan - Women's Huron Valley Correctional Facility": "3007",
  "Michigan - Woodland Center Correctional Facility": "3011",
  "Minnesota - Duluth FPC": "1765",
  "Minnesota - MCF Faribault": "2225",
  "Minnesota - MCF Lino Lakes": "2227",
  "Minnesota - MCF Moose Lake": "2236",
  "Minnesota - MCF Oak Park Heights": "2228",
  "Minnesota - MCF Red Wing Adult": "2229",
  "Minnesota - MCF Rush City": "2230",
  "Minnesota - MCF Saint Cloud": "2231",
  "Minnesota - MCF Shakopee": "2232",
  "Minnesota - MCF Stillwater": "2234",
  "Minnesota - MCF Togo": "2235",
  "Minnesota - Rochester FMC": "1742",
  "Minnesota - Sandstone FCI": "1692",
  "Minnesota - Waseca FCI": "1703",
  "Missouri - Algoa Correctional Center": "1022",
  "Missouri - Boonville Correctional Center": "1210",
  "Missouri - Chillicothe Correctional Center": "1377",
  "Missouri - Eastern Reception, Diagnostic and Correctional Center": "1595",
  "Missouri - Farmington Correctional Center Side A": "1635",
  "Missouri - Farmington Correctional Center Side B": "1636",
  "Missouri - Fulton Reception and Diagnostic Center": "1794",
  "Missouri - Jefferson City Correctional Center": "1992",
  "Missouri - Maryville Treatment Center": "2206",
  "Missouri - Missouri Eastern Correctional Center": "2301",
  "Missouri - Moberly Correctional Center": "2303",
  "Missouri - Northeast Correctional Center": "2384",
  "Missouri - Ozark Correctional Center": "2460",
  "Missouri - Potosi Correctional Center": "2524",
  "Missouri - South Central Correctional Center": "2725",
  "Missouri - Southeast Correctional Center": "2743",
  "Missouri - Springfield FMC": "2863",
  "Missouri - Tipton Correctional Center": "2834",
  "Missouri - Western Reception Diagnostic and Correctional Center": "2974",
  "Missouri - Women's Eastern Reception, Diagnostic and Corr. Ctr": "3006",
  "Mississippi - Alcorn County Regional Correctional Facility": "1018",
  "Mississippi - Central Mississippi Correctional Facility": "1341",
  "Mississippi - Central Mississippi Correctional Facility - Women": "3431",
  "Mississippi - Chickasaw County Regional Correctional Facility": "1375",
  "Mississippi - Delta Correctional Facility": "1529",
  "Mississippi - Desoto County Adult Correction Center": "3362",
  "Mississippi - East Mississippi Correctional Facility": "1583",
  "Mississippi - Flowood Restitution and Correctional Work Release": "1737",
  "Mississippi - Forrest County Community Work Center": "1752",
  "Mississippi - George/Greene County Regional Correctional Facility": "1811",
  "Mississippi - Issaquena County Correctional Facility": "1972",
  "Mississippi - Jefferson/Franklin Correctional Facility": "1997",
  "Mississippi - Kemper-Neshoba Regional Correctional Facility": "3373",
  "Mississippi - Leake County Regional Correctional Facility": "2084",
  "Mississippi - Marion County/Regional Correctional Facility": "2187",
  "Mississippi - Marshall County Correctional Facility": "2192",
  "Mississippi - Mississippi State Penitentiary": "2298",
  "Mississippi - Noxubee County Community Work Center": "2411",
  "Mississippi - South Mississippi Correctional Institution": "2737",
  "Mississippi - Stone County Regional Correctional Facility": "2783",
  "Mississippi - Tallahatchie County Correctional Facility": "2810",
  "Mississippi - Walnut Grove Correctional Facility": "2916",
  "Mississippi - Wilkinson County Correctional Facility": "2986",
  "Mississippi - Yazoo City FCC": "1705",
  "Montana - Crossroads Correctional Center": "1484",
  "Montana - Dawson County Adult Detention/Corrections Facility": "1514",
  "Montana - Elkhorn Treatment Center": "1612",
  "Montana - Montana State Prison": "2307",
  "Montana - Montana Women's Prison": "2308",
  "North Carolina - Albemarle Correctional Institution": "1015",
  "North Carolina - Alexander Correctional Institution": "1020",
  "North Carolina - Anson Correctional Institution": "2067",
  "North Carolina - Anson Correctional Institution - Minimum": "1237",
  "North Carolina - Bertie Correctional Institution": "1181",
  "North Carolina - Buncombe County Detention Facility": "3493",
  "North Carolina - Butner FMC": "1717",
  "North Carolina - Butner Low FCI": "1639",
  "North Carolina - Butner Medium I FCI": "1657",
  "North Carolina - Butner Medium II FCI": "1658",
  "North Carolina - Caldwell Correctional Center": "1259",
  "North Carolina - Carteret Correctional Center": "1307",
  "North Carolina - Caswell Correctional Center": "1310",
  "North Carolina - Catawba Correctional Center": "1312",
  "North Carolina - Central Prison": "1344",
  "North Carolina - Columbus Correctional Institution": "1447",
  "North Carolina - Craggy Correctional Center - MED": "1477",
  "North Carolina - Craven Correctional Institution": "1480",
  "North Carolina - Cumberland County Detention Center": "3387",
  "North Carolina - Dan River Prison Work Farm": "1503",
  "North Carolina - Davidson Correctional Center": "1511",
  "North Carolina - Eastern Correctional Institution": "1587",
  "North Carolina - Foothills Correctional Institution": "1745",
  "North Carolina - Forsyth Correctional Center": "1753",
  "North Carolina - Franklin Correctional Center": "1777",
  "North Carolina - Gaston Correctional Center": "1804",
  "North Carolina - Granville Correctional Institution": "2513",
  "North Carolina - Greene Correctional Institution": "1845",
  "North Carolina - Harnett Correctional Institution": "1878",
  "North Carolina - Hyde Correctional Institution": "1943",
  "North Carolina - Johnston Correctional Institution": "2011",
  "North Carolina - Lincoln Correctional Center": "2107",
  "North Carolina - Lumberton Correctional Institution": "2139",
  "North Carolina - Marion Correctional Institution": "2182",
  "North Carolina - Maury Correctional Institution": "2210",
  "North Carolina - MCI East Regional Brig": "1289",
  "North Carolina - Mountain View Correctional Institution": "2329",
  "North Carolina - Nash Correctional Institution": "2339",
  "North Carolina - Neuse Correctional Institution": "2346",
  "North Carolina - New Hanover Correctional Center": "2352",
  "North Carolina - North Carolina Correctional Institution For Women- NCCIW": "2367",
  "North Carolina - Orange Correctional Center": "2441",
  "North Carolina - Pamlico Correctional Institution": "2466",
  "North Carolina - Pasquotank Correctional Institution": "2472",
  "North Carolina - Pender Correctional Institution": "2477",
  "North Carolina - Piedmont Correctional Institution": "2492",
  "North Carolina - Raleigh Unit  - NCCIW (Canary Unit)": "2553",
  "North Carolina - Richmond Correctional Institution": "2320",
  "North Carolina - Roanoke River Correctional Institution": "1261",
  "North Carolina - Rutherford Correctional Center": "2622",
  "North Carolina - Sampson Correctional Institution": "2643",
  "North Carolina - Sanford Correctional Center": "2652",
  "North Carolina - Scotland Correctional Institution": "2690",
  "North Carolina - Southern Correctional Institution": "2746",
  "North Carolina - Swain County Detention Center": "3562",
  "North Carolina - Tabor Correctional Institution": "2805",
  "North Carolina - Tyrrell Prison Work Farm": "2862",
  "North Carolina - Wake Correctional Center": "2905",
  "North Carolina - Warren Correctional Institution": "2924",
  "North Carolina - Western Correctional Center for Women": "2804",
  "North Carolina - Wilkes Correctional Center": "2985",
  "North Dakota - Dakota Women's Correctional Rehabilitation Center": "1497",
  "North Dakota - Heart River Correctional Center": "3626",
  "North Dakota - James River Correctional Center": "1986",
  "North Dakota - Missouri River Correctional Center": "2302",
  "North Dakota - North Dakota State Penitentiary": "2372",
  "Nebraska - Community Corrections Center - Lincoln": "1452",
  "Nebraska - Community Corrections Center of Omaha": "1453",
  "Nebraska - Nebraska Correctional Center for Women": "2343",
  "Nebraska - Nebraska Correctional Youth Facility": "2344",
  "Nebraska - Nebraska State Penitentiary": "2345",
  "Nebraska - Nebraska Work Ethic Camp": "3509",
  "Nebraska - Omaha Correctional Center": "2436",
  "Nebraska - Reception Treatment Center": "2106",
  "Nebraska - Tecumseh State Correctional Institution": "2818",
  "Nebraska - Work Ethic Camp": "3013",
  "New Hampshire - Berlin FCI": "1774",
  "New Hampshire - New Hampshire Correctional Facility for Women": "3216",
  "New Hampshire - New Hampshire State Prison for Men": "2350",
  "New Hampshire - Northern New Hampshire Correctional Facility": "2395",
  "New Jersey - Bayside State Prison": "1160",
  "New Jersey - Burlington County Detention Facility": "1250",
  "New Jersey - East Jersey State Prison": "1581",
  "New Jersey - Edna Mahan Correctional Facility for Women": "1602",
  "New Jersey - Fairton FCI": "1664",
  "New Jersey - Fort Dix FCI": "1666",
  "New Jersey - Garden State Youth Correctional Facility": "1800",
  "New Jersey - Hudson County Department of Corrections Rehabilitation Center": "3227",
  "New Jersey - Mid-State Correctional Facility": "2285",
  "New Jersey - New Jersey State Prison": "2354",
  "New Jersey - Northern State Prison": "2398",
  "New Jersey - South Woods State Prison": "2739",
  "New Jersey - William Fauver Youth Correctional Facility": "2331",
  "New Mexico - Central New Mexico Correctional Facility": "1342",
  "New Mexico - Cibola County Correctional Center": "1384",
  "New Mexico - Guadalupe County Correctional Facility": "1854",
  "New Mexico - La Tuna FCI": "2050",
  "New Mexico - Lea County Correctional Facility": "2083",
  "New Mexico - Metropolitan Detention Center - Bernalillo": "2270",
  "New Mexico - Northeast New Mexico Detention Facility": "2391",
  "New Mexico - Otero County Prison Facility": "2455",
  "New Mexico - Penitentiary of New Mexico": "2480",
  "New Mexico - Roswell Correctional Center": "2615",
  "New Mexico - Southern New Mexico Correctional Facility": "2750",
  "New Mexico - Springer Correctional Center": "2765",
  "New Mexico - Torrance County Detention Center": "2840",
  "New Mexico - Western New Mexico Correctional Facility - North": "2973",
  "New Mexico - Western New Mexico Correctional Facility - South": "2356",
  "Nevada - Carlin Conservation Camp": "1301",
  "Nevada - Casa Grande Transition Center": "1308",
  "Nevada - Ely State Prison": "1620",
  "Nevada - Florence McClure Women's Correctional  Center": "1731",
  "Nevada - High Desert State Prison": "1903",
  "Nevada - Jean Conservation Camp": "1991",
  "Nevada - Lovelock Correctional Center": "2129",
  "Nevada - Nevada Southern Detention Center": "2347",
  "Nevada - Northern Nevada Correctional Center": "2394",
  "Nevada - Northern Nevada Transitional Housing": "3050",
  "Nevada - Pioche Conservation Camp": "2500",
  "Nevada - Southern Desert Correctional Center": "2747",
  "Nevada - Stewart Conservation Camp": "2778",
  "Nevada - Three Lakes Valley Conservation Camp": "3359",
  "Nevada - Wells Conservation Camp": "2957",
  "New York - Albion Correctional Facility": "1017",
  "New York - Altona Correctional Facility": "1031",
  "New York - Attica Correctional Facility": "1124",
  "New York - Auburn Correctional Facility": "1125",
  "New York - Bare Hill Correctional Facility": "1149",
  "New York - Bedford Hills Correctional Facility": "1170",
  "New York - Brooklyn MDC": "2268",
  "New York - Cape Vincent Correctional Facility": "1298",
  "New York - Cayuga Correctional Facility": "1314",
  "New York - Chautauqua County Jail": "1369",
  "New York - Clinton Correctional Facility": "1399",
  "New York - Collins Correctional Facility": "1433",
  "New York - Coxsackie Correctional Facility": "1474",
  "New York - Eastern New York Correctional Facility": "1592",
  "New York - Edgecombe Residential Treatment Facility": "1598",
  "New York - Elmira Correctional Facility": "1615",
  "New York - Fishkill Correctional Facility": "1726",
  "New York - Five Points Correctional Facility": "1727",
  "New York - Franklin Correctional Facility": "1778",
  "New York - Gouverneur Correctional Facility": "1827",
  "New York - Great Meadow Correctional Facility": "1838",
  "New York - Green Haven Correctional Facility": "1841",
  "New York - Greene Correctional Facility": "1844",
  "New York - Groveland Correctional Facility": "1852",
  "New York - Hale Creek ASACTC": "1864",
  "New York - Hudson Correctional Facility": "1933",
  "New York - Lakeview Shock Incarceration Facility": "2061",
  "New York - Marcy Correctional Facility": "2177",
  "New York - Mid-State Correctional Facility": "2286",
  "New York - Mohawk Correctional Facility": "2306",
  "New York - Orleans Correctional Facility": "2450",
  "New York - Orleans County Jail": "3559",
  "New York - Otisville Correctional Facility": "2456",
  "New York - Otisville FCI": "1714",
  "New York - Queensboro Correctional Facility": "2543",
  "New York - Ray Brook FCI": "1715",
  "New York - Rensselaer County Jail": "2570",
  "New York - Riverview Correctional Facility": "2600",
  "New York - Rose M Singer Center": "2613",
  "New York - Shawangunk Correctional Facility": "2702",
  "New York - Sing Sing Correctional Facility": "2713",
  "New York - Sullivan Correctional Facility": "2789",
  "New York - Taconic Correctional Facility": "2806",
  "New York - Ulster Correctional Facility": "2864",
  "New York - Upstate Correctional Facility": "2873",
  "New York - Wallkill Correctional Facility": "2915",
  "New York - Washington Correctional Facility": "2929",
  "New York - Wende Correctional Facility": "2958",
  "New York - Westchester County Jail": "2968",
  "New York - Woodbourne Correctional Facility": "3009",
  "New York - Wyoming Correctional Facility": "3016",
  "Ohio - Allen Oakwood Correctional Institution": "1027",
  "Ohio - Belmont Correctional Institution": "1173",
  "Ohio - Chillicothe Correctional Institution": "1378",
  "Ohio - Correctional Reception Center": "1467",
  "Ohio - Cuyahoga County Correctional Facility": "3284",
  "Ohio - Dayton Correctional Institution": "1516",
  "Ohio - Elkton FCI": "1661",
  "Ohio - Franklin Medical Center": "1783",
  "Ohio - Grafton Correctional Institution": "1831",
  "Ohio - Grafton Reintegration Center": "1832",
  "Ohio - Lake Erie Correctional Institution": "2057",
  "Ohio - Lebanon Correctional Institution": "2086",
  "Ohio - London Correctional Institution": "2119",
  "Ohio - Lorain Correctional Institution": "2123",
  "Ohio - Madison Correctional Institution - Zone A": "3437",
  "Ohio - Madison Correctional Institution - Zone B": "2160",
  "Ohio - Mansfield Correctional Institution": "2173",
  "Ohio - Marion Correctional Institution": "2183",
  "Ohio - Noble Correctional Institution": "2365",
  "Ohio - North Central Correctional Complex": "2368",
  "Ohio - Northeast Ohio Correctional Center": "2387",
  "Ohio - Northeast Reintegration Center": "2389",
  "Ohio - Ohio Reformatory for Women": "2423",
  "Ohio - Ohio State Penitentiary": "2424",
  "Ohio - Pickaway Correctional Institution": "2491",
  "Ohio - Richland Correctional Institution": "2581",
  "Ohio - Ross Correctional Institution": "2614",
  "Ohio - Southeastern Correctional Institution": "2745",
  "Ohio - Southern Ohio Correctional Facility": "2751",
  "Ohio - Toledo Correctional Institution": "2836",
  "Ohio - Trumbull Correctional Institution": "2852",
  "Ohio - Warren Correctional Institution": "2925",
  "Oklahoma - Allen Gamble Correctional Facility": "1512",
  "Oklahoma - Charles E Bill Johnson Correctional Center": "1362",
  "Oklahoma - Cimarron Correctional Facility": "1386",
  "Oklahoma - Clara Waters Community Corrections Center": "3080",
  "Oklahoma - Dick Conner Correctional Center": "1549",
  "Oklahoma - Eddie Warrior Correctional Center": "1564",
  "Oklahoma - El Reno FCI": "1660",
  "Oklahoma - Great Plains Correctional Institution": "1839",
  "Oklahoma - Howard McLeod Correctional Center": "1931",
  "Oklahoma - Jackie Brannon Correctional Center": "1977",
  "Oklahoma - James Crabtree Correctional Center": "1984",
  "Oklahoma - Jess Dunn Correctional Center": "1998",
  "Oklahoma - Jim E. Hamilton Correctional Center": "2005",
  "Oklahoma - John Lilley Correctional Center": "2009",
  "Oklahoma - Joseph Harp Correctional Center": "2014",
  "Oklahoma - Lawton Community Corrections Center": "2080",
  "Oklahoma - Lawton Correctional and Rehabilitation Facility": "2081",
  "Oklahoma - Lexington Assessment and Reception Center": "2097",
  "Oklahoma - Mabel Bassett Correctional Center": "2147",
  "Oklahoma - Mack Alford Correctional Center": "2150",
  "Oklahoma - Northeast Oklahoma Correctional Center": "2388",
  "Oklahoma - Oklahoma City FTC": "1721",
  "Oklahoma - Oklahoma State Penitentiary": "2431",
  "Oklahoma - Oklahoma State Reformatory": "2432",
  "Oklahoma - ReMerge -Women's Firstep Work Recovery": "3358",
  "Oklahoma - Union City Community Corrections Center": "2866",
  "Oregon - Coffee Creek Correctional Facility Intake": "1425",
  "Oregon - Coffee Creek Correctional Facility Minimum Unit": "1426",
  "Oregon - Coffee Creek Correctional Facility-Med-Max": "1427",
  "Oregon - Columbia River Correctional Institution": "1445",
  "Oregon - Deer Ridge Correctional Institution": "1522",
  "Oregon - Eastern Oregon Correctional Institution": "1593",
  "Oregon - Lincoln County Jail": "2109",
  "Oregon - Oregon State Correctional Institution": "2445",
  "Oregon - Oregon State Penitentiary": "2446",
  "Oregon - Powder River Correctional Facility": "2525",
  "Oregon - Santiam Correctional Institution": "2660",
  "Oregon - Sheridan FCI": "1694",
  "Oregon - Snake River Correctional Institution": "2719",
  "Oregon - Snake River Correctional Institution - Minimum Security Unit": "3271",
  "Oregon - South Fork Forest Camp": "2732",
  "Oregon - Two Rivers Correctional Institution": "2860",
  "Oregon - Warner Creek Correctional Facility": "2923",
  "Pennsylvania - Adams County Adult Correctional Complex": "3355",
  "Pennsylvania - Allegheny County Jail": "1023",
  "Pennsylvania - Allenwood  Low FCI": "1651",
  "Pennsylvania - Allenwood Medium FCI": "1652",
  "Pennsylvania - Allenwood USP": "2874",
  "Pennsylvania - Butler County Prison": "1253",
  "Pennsylvania - Canaan USP": "2877",
  "Pennsylvania - Chester County Prison": "3441",
  "Pennsylvania - Clinton County Correctional Facility": "3091",
  "Pennsylvania - Curran-Fromhold Correctional Facility": "1489",
  "Pennsylvania - George W Hill Correctional Facility": "3357",
  "Pennsylvania - Lewisburg FCI": "2883",
  "Pennsylvania - Loretto FCI": "1672",
  "Pennsylvania - McKean FCI": "1678",
  "Pennsylvania - Moshannon Valley Processing Center": "2323",
  "Pennsylvania - Philadelphia FDC": "1708",
  "Pennsylvania - Philadelphia Industrial Correctional": "2488",
  "Pennsylvania - Quehanna Boot Camp": "2544",
  "Pennsylvania - Schuylkill FCI": "1693",
  "Pennsylvania - SCI Albion": "2663",
  "Pennsylvania - SCI Benner Township": "2664",
  "Pennsylvania - SCI Cambridge Springs": "2665",
  "Pennsylvania - SCI Camp Hill": "2666",
  "Pennsylvania - SCI Chester": "2667",
  "Pennsylvania - SCI Coal Township": "2668",
  "Pennsylvania - SCI Dallas": "2670",
  "Pennsylvania - SCI Fayette": "2671",
  "Pennsylvania - SCI Forest": "2672",
  "Pennsylvania - SCI Frackville": "2673",
  "Pennsylvania - SCI Greene": "2676",
  "Pennsylvania - SCI Houtzdale": "2677",
  "Pennsylvania - SCI Huntingdon": "2678",
  "Pennsylvania - SCI Laurel Highlands": "2679",
  "Pennsylvania - SCI Mahanoy": "2680",
  "Pennsylvania - SCI Mercer": "2681",
  "Pennsylvania - SCI Muncy": "2682",
  "Pennsylvania - SCI Phoenix": "3246",
  "Pennsylvania - SCI Pine Grove": "2683",
  "Pennsylvania - SCI Rockview": "2686",
  "Pennsylvania - SCI Smithfield": "2687",
  "Pennsylvania - SCI Somerset": "2688",
  "Pennsylvania - SCI Waymart": "2689",
  "Pennsylvania - York County Prison": "3429",
  "Rhode Island - Donald W. Wyatt Detention Center": "1558",
  "Rhode Island - Gloria McDonald Women's Facility": "2579",
  "Rhode Island - High Security Center": "1906",
  "Rhode Island - John J. Moran Medium Security Facility": "2007",
  "Rhode Island - Rhode Island Intake Service Center": "2574",
  "Rhode Island - Rhode Island Maximum Security Facility": "2575",
  "Rhode Island - Rhode Island Minimum Facility": "2577",
  "South Carolina - Allendale Correctional Institution": "1028",
  "South Carolina - Alvin S. Glenn Detention Center": "1033",
  "South Carolina - Anderson County Detention Center": "1037",
  "South Carolina - Bennettsville FCI": "1655",
  "South Carolina - Broad River Correctional Institution": "1228",
  "South Carolina - Camille Griffin Graham Correctional Institution": "1280",
  "South Carolina - Edgefield FCI": "1599",
  "South Carolina - Estill FCI": "1663",
  "South Carolina - Evans Correctional Institution": "1631",
  "South Carolina - Goodman Correctional Institution": "1822",
  "South Carolina - Kershaw Correctional Institution": "2037",
  "South Carolina - Kirkland Reception and Evaluation Center": "2042",
  "South Carolina - Leath Correctional Institution": "2085",
  "South Carolina - Lee Correctional Institution": "2089",
  "South Carolina - Lieber Correctional Institution": "2100",
  "South Carolina - Livesay Correctional Institution - Camp B": "2112",
  "South Carolina - Livesay Correctional Institution Camp A": "2113",
  "South Carolina - MacDougall Correctional Institution": "2148",
  "South Carolina - Manning Correctional Institution": "2172",
  "South Carolina - McCormick Correctional Institution": "2223",
  "South Carolina - Palmer Pre-Release Center": "2463",
  "South Carolina - Perry Correctional Institution": "2482",
  "South Carolina - Ridgeland Correctional Institution": "2586",
  "South Carolina - Trenton Correctional Institution": "2848",
  "South Carolina - Turbeville Correctional Institution": "2856",
  "South Carolina - Tyger River Institution": "2861",
  "South Carolina - Wateree River Correctional Institution": "2943",
  "South Carolina - Williamsburg FCI": "1704",
  "South Carolina - York County Detention Center": "3735",
  "South Dakota - Mike Durfee State Prison": "2289",
  "South Dakota - Minnehaha County Jail": "3150",
  "South Dakota - Pennington County Jail": "3149",
  "South Dakota - Rapid City Minimum Unit": "2558",
  "South Dakota - South Dakota State Penitentiary - Hill": "2728",
  "South Dakota - South Dakota State Penitentiary Jameson Annex": "1989",
  "South Dakota - South Dakota State Penitentiary Trustee Unit C": "2729",
  "South Dakota - South Dakota Women's Prison": "2730",
  "South Dakota - Yankton FPC": "1773",
  "South Dakota - Yankton Minimum Unit": "3025",
  "Tennessee - Bledsoe County Correctional Complex": "1204",
  "Tennessee - Debra K Johnson Rehabilitation Center": "2821",
  "Tennessee - Hamilton County Jail and Detention Center": "3737",
  "Tennessee - Hardeman County Correctional Center": "1876",
  "Tennessee - Lois M DeBerry Special Needs Facility": "2118",
  "Tennessee - Mark H Luttrell Transition Center": "2188",
  "Tennessee - Memphis FCI": "1680",
  "Tennessee - Morgan County Correctional Facility": "2318",
  "Tennessee - Northeast Correctional Complex": "2385",
  "Tennessee - Northwest Correctional Complex - Site One": "2402",
  "Tennessee - Northwest Correctional Complex - Site Two": "2403",
  "Tennessee - Riverbend Maximum Security Institution": "2593",
  "Tennessee - Shelby County Jail / Work camp": "3360",
  "Tennessee - Silverdale Detention Center": "2712",
  "Tennessee - South Central Correctional Facility": "2726",
  "Tennessee - Trousdale Turner Correctional Center": "2851",
  "Tennessee - Turney Center Industrial Complex": "2859",
  "Tennessee - Wayne County Annex": "2952",
  "Tennessee - West Tennessee State Penitentiary - Site Three (MSC Annex)": "3049",
  "Tennessee - West Tennessee State Penitentiary - Site Two": "2966",
  "Tennessee - West Tennessee State Penitentiary- Site One": "3048",
  "Tennessee - Whiteville Correctional Facility": "2981",
  "Texas - Allred Unit - TDCJ": "1029",
  "Texas - BAMBI -  Santa Maria Hostel, Inc.": "3100",
  "Texas - Bartlett Unit": "1151",
  "Texas - Bastrop FCI": "1154",
  "Texas - Beaumont Low FCI": "1165",
  "Texas - Beaumont Medium FCI": "1637",
  "Texas - Beaumont USP": "1166",
  "Texas - Beto Unit - TDCJ": "1182",
  "Texas - Big Spring FCI": "1192",
  "Texas - Billy Moore Correctional Facility - TDCJ": "1141",
  "Texas - Bluebonnet Detention Center": "3463",
  "Texas - Bowie County Correctional Center": "3082",
  "Texas - Boyd Unit": "1214",
  "Texas - Bradshaw State Jail": "1217",
  "Texas - Bridgeport Correctional Center": "1220",
  "Texas - Briscoe Unit": "1226",
  "Texas - Bryan FPC": "1241",
  "Texas - Buster Cole State Jail": "1432",
  "Texas - Byrd Unit": "1254",
  "Texas - Carol S.Vance Unit": "2890",
  "Texas - Carole S Young Medical Facility": "3030",
  "Texas - Carswell FMC": "1740",
  "Texas - Choice Moore Transfer Facility": "1256",
  "Texas - Clemens Unit": "1393",
  "Texas - Clements Unit": "1394",
  "Texas - Coastal Bend Detention Center": "3370",
  "Texas - Coffield Unit - TDCJ": "1429",
  "Texas - Connally Unit": "1456",
  "Texas - Cotulla Transfer Facility": "1472",
  "Texas - Crain Unit": "1478",
  "Texas - Dalhart Unit - TDCJ": "1500",
  "Texas - Daniel Unit - TDCJ": "1505",
  "Texas - Denton County Jail": "3195",
  "Texas - Diboll Correctional Center": "1548",
  "Texas - Dominguez State Jail": "1557",
  "Texas - Duncan Unit": "1570",
  "Texas - Eagle Pass Correctional Facility": "3255",
  "Texas - East Texas Treatment Facility": "1585",
  "Texas - Eden Detention Center": "1597",
  "Texas - Ellis Unit": "1613",
  "Texas - Estelle Unit": "1627",
  "Texas - Ferguson Unit - TDCJ": "1725",
  "Texas - Fort Stockton Transfer Facility - TDCJ": "1756",
  "Texas - Fort Worth FMC": "1667",
  "Texas - Garza West Transfer Facility": "1803",
  "Texas - Gist State Jail": "1815",
  "Texas - Glossbrenner SAFPF": "1819",
  "Texas - Goodman Unit": "1823",
  "Texas - Goree Unit": "1826",
  "Texas - Gregory S Coleman Unit": "2115",
  "Texas - Halbert SAFPF": "1863",
  "Texas - Hamilton Unit": "1869",
  "Texas - Havins Unit": "1883",
  "Texas - Henley State Jail": "1896",
  "Texas - Hightower Unit": "1907",
  "Texas - Hilltop Unit": "1913",
  "Texas - Hobby Unit": "1915",
  "Texas - Hodge Unit - TDCJ": "1917",
  "Texas - Holliday Transfer Facility": "1919",
  "Texas - Hospital Galveston Medical Facility": "1927",
  "Texas - Houston FDC": "1929",
  "Texas - Hughes Unit": "1935",
  "Texas - Huntsville Unit": "1938",
  "Texas - Hutchins State Jail - TDCJ": "1940",
  "Texas - J B Wheeler Unit": "2980",
  "Texas - Jester III Unit": "2003",
  "Texas - Joe Corley Processing Center": "3638",
  "Texas - John R. Lindsey State Jail": "2110",
  "Texas - Johnston SAFPF - TDCJ": "2012",
  "Texas - Jordan Unit - TDCJ": "2013",
  "Texas - Kegans ISF": "2028",
  "Texas - Kyle Correctional Center": "2048",
  "Texas - Lane Murray Unit": "2334",
  "Texas - Leblanc Unit": "2087",
  "Texas - Lewis Unit - TDCJ": "2096",
  "Texas - Lopez State Jail": "2122",
  "Texas - Luther Unit": "2143",
  "Texas - Lychner State Jail": "2144",
  "Texas - Lynaugh Unit - TDCJ": "2145",
  "Texas - Marlin Transfer Facility": "2189",
  "Texas - Marshall Formby Unit - TDCJ": "1748",
  "Texas - McConnell Unit": "2222",
  "Texas - Memorial Unit": "1508",
  "Texas - Michael Unit - TDCJ": "2279",
  "Texas - Middleton Transfer Facility - TDCJ": "2288",
  "Texas - Montford Trusty Camp": "3289",
  "Texas - Montford Unit - TDCJ": "2310",
  "Texas - Ney State Jail": "2363",
  "Texas - O'Daniel Unit": "2330",
  "Texas - Oliver J Bell Unit": "1395",
  "Texas - Pack Unit": "2462",
  "Texas - Plane State Jail": "2507",
  "Texas - Polunsky Unit - TDCJ": "2518",
  "Texas - Powledge Unit - TDCJ": "2528",
  "Texas - Prairieland Detention Center": "3394",
  "Texas - Preston E.Smith Unit": "2718",
  "Texas - Ramsey Unit": "2554",
  "Texas - Roach Unit - TDCJ": "2602",
  "Texas - Robertson Unit - TDCJ": "2605",
  "Texas - Rogelio Sanchez State Jail": "2650",
  "Texas - San Saba Unit": "2649",
  "Texas - Sanders Estes Unit": "1629",
  "Texas - Seagoville FCI": "2694",
  "Texas - Segovia Transfer Facility": "2698",
  "Texas - Skyview  Hodge Unit - TDCJ": "2715",
  "Texas - Stevenson Unit": "2777",
  "Texas - Stiles Unit": "2780",
  "Texas - Stringfellow Unit": "2784",
  "Texas - Taylor County Jail": "3193",
  "Texas - Telford Unit - TDCJ": "2820",
  "Texas - Terrell Unit": "2825",
  "Texas - Texarkana FCI": "2828",
  "Texas - Thomas Mechler Unit ( formerly Tulia Transfer Facility)": "2855",
  "Texas - Three Rivers FCI": "2831",
  "Texas - Torres Unit": "2841",
  "Texas - Travis County State Jail": "2847",
  "Texas - Wainwright Unit- TDCJ": "1596",
  "Texas - Walker Sayle Unit - SAFPF - TDCJ": "2661",
  "Texas - Wallace Unit - TDCJ": "2913",
  "Texas - Wayne Scott Unit (Psych)": "2004",
  "Texas - Willacy County State Jail": "2988",
  "Texas - Woodman State Jail": "3012",
  "Texas - Wynne Unit": "3015",
  "Utah - Central Utah Correctional Facility": "1348",
  "Utah - Utah State Correctional Facility": "3395",
  "Utah - Wasatch County Jail": "2926",
  "Virginia - Baskerville Correctional Center": "1153",
  "Virginia - Beaumont Correctional Facility": "3379",
  "Virginia - Bland Correctional Center": "1203",
  "Virginia - Buckingham Correctional Center": "1242",
  "Virginia - Caroline Correctional Unit #2": "1302",
  "Virginia - Central Virginia Correctional Unit #13": "1351",
  "Virginia - Chesterfield Womens CCAP": "3698",
  "Virginia - Coffeewood Correctional Center": "1428",
  "Virginia - Cold Springs Correctional Center - Unit 10": "1430",
  "Virginia - Deerfield Correctional Center": "1523",
  "Virginia - Deerfield Work Center for Men": "1525",
  "Virginia - Dillwyn Correctional Center": "1550",
  "Virginia - FCI Petersburg DO NOT USE": "3213",
  "Virginia - Fluvanna Correctional Center for Women": "1739",
  "Virginia - Green Rock Correctional Center": "1843",
  "Virginia - Greensville Correctional Center - S2": "1847",
  "Virginia - Greensville Correctional Center - S3": "1848",
  "Virginia - Greensville Work Center -S1": "1849",
  "Virginia - Halifax Correctional Unit #23": "1865",
  "Virginia - Haynesville Correctional Center": "1887",
  "Virginia - Indian Creek Correctional Center": "1953",
  "Virginia - Keen Mountain Correctional Center": "2026",
  "Virginia - Lawrenceville Correctional Center": "2078",
  "Virginia - Lee USP": "2882",
  "Virginia - Lunenburg Correctional Center": "2140",
  "Virginia - Marion Correctional Treatment Center": "2184",
  "Virginia - Nottoway Correctional Center": "2410",
  "Virginia - Page County Jail": "3633",
  "Virginia - Patrick Henry Correctional Unit #28": "2474",
  "Virginia - Petersburg Low FCI": "2485",
  "Virginia - Petersburg Medium FCI": "2486",
  "Virginia - Pocahontas State Correctional Center": "2510",
  "Virginia - Red Onion State Prison": "2563",
  "Virginia - River North Correctional Center": "2591",
  "Virginia - Riverside Regional Jail": "2599",
  "Virginia - Rustburg Correctional Unit #9": "2621",
  "Virginia - Saint Brides Correctional Center": "2632",
  "Virginia - State Farm Correctional Center": "1521",
  "Virginia - State Farm Work Center": "1987",
  "Virginia - Sussex I State Prison": "2797",
  "Virginia - Virginia Correctional Center for Women": "2901",
  "Virginia - Wallens Ridge State Prison": "2914",
  "Virginia - William G Truesdale Adult Detention Center": "2992",
  "Virginia - Wise Correctional Unit": "3002",
  "Vermont - Chittenden Regional Correctional Facility": "1381",
  "Vermont - Marble Valley Regional Correctional Facility": "2176",
  "Vermont - Northern State Correctional Facility": "2397",
  "Vermont - Southern State Correctional Facility": "2753",
  "Washington - Airway Heights Corrections Center": "1013",
  "Washington - Benton County Jail": "3155",
  "Washington - Cedar Creek Corrections Center": "1324",
  "Washington - Clallam Bay Corrections Center": "1388",
  "Washington - Clark County Corrections": "3391",
  "Washington - Coyote Ridge Corrections Center": "1475",
  "Washington - Eastern State Hospital": "3291",
  "Washington - King County Correctional Facility": "3228",
  "Washington - MCC Minimum Security Unit": "2216",
  "Washington - MCC Special Offenders Unit": "2217",
  "Washington - MCC Twin Rivers Corrections Center": "2218",
  "Washington - Mission Creek Corrections Center for Women": "2297",
  "Washington - Olympic Corrections Center": "2435",
  "Washington - SeaTac FDC": "1709",
  "Washington - Stafford Creek Corrections Center": "2767",
  "Washington - Washington Corrections Center": "2930",
  "Washington - Washington Corrections Center for Women": "2931",
  "Washington - Washington State Penitentiary East Complex": "2938",
  "Washington - Washington State Penitentiary West Complex": "2939",
  "Washington - Washington State South Complex": "3620",
  "Wisconsin - Chippewa Valley Correctional Treatment Facility": "1380",
  "Wisconsin - Columbia Correctional Institution": "1440",
  "Wisconsin - Dodge Correctional Institution": "1555",
  "Wisconsin - Drug Abuse Correctional Center": "1566",
  "Wisconsin - Flambeau Correctional Center": "1728",
  "Wisconsin - Fox Lake Correctional Institution": "1760",
  "Wisconsin - Gordon Correctional Center": "1825",
  "Wisconsin - Green Bay Correctional Institution": "1840",
  "Wisconsin - Jackson Correctional Institution": "1979",
  "Wisconsin - John C Burke Correctional Center": "2006",
  "Wisconsin - Kettle Moraine Correctional Institution": "2038",
  "Wisconsin - Marshall Sherrer Correctional Center": "3652",
  "Wisconsin - McNaughton Correctional Center": "2247",
  "Wisconsin - Milwaukee County Community Reintegration Center": "3253",
  "Wisconsin - Milwaukee Secure Detention Facility": "2293",
  "Wisconsin - Milwaukee Women's Correctional Center": "2294",
  "Wisconsin - New Lisbon Correctional Institution": "2355",
  "Wisconsin - Oakhill Correctional Institution": "2416",
  "Wisconsin - Oregon Correctional Center": "2443",
  "Wisconsin - Oshkosh Correctional Institution": "2453",
  "Wisconsin - Oxford FCI": "1688",
  "Wisconsin - Prairie Du Chien Correctional Institution": "2531",
  "Wisconsin - Racine Correctional Institution": "2547",
  "Wisconsin - Racine Youthful Offender Correctional Facility": "2549",
  "Wisconsin - Redgranite Correctional Institution": "2565",
  "Wisconsin - Robert E Ellsworth Correctional Center": "2603",
  "Wisconsin - Saint Croix Correctional Center": "2636",
  "Wisconsin - Sanger B Powers Correctional Center": "2653",
  "Wisconsin - Stanley Correctional Institution": "2770",
  "Wisconsin - Sturtevant Transitional Facility (Satellite of Racine Corr)": "2785",
  "Wisconsin - Taycheedah Correctional Institution": "2812",
  "Wisconsin - Waukesha County Jail": "2946",
  "Wisconsin - Waupun Correctional Institution": "2947",
  "Wisconsin - Winnebago Correctional Center": "2998",
  "Wisconsin - Wisconsin Resource Center": "3000",
  "Wisconsin - Wisconsin Secure Program Facility": "3001",
  "West Virginia - Alderson FPC": "1720",
  "West Virginia - Beckley Correctional Center": "1169",
  "West Virginia - Beckley FCI": "1716",
  "West Virginia - Charleston Correctional Center": "1363",
  "West Virginia - Denmar Correctional Center": "1532",
  "West Virginia - Eastern Regional Jail and Correctional Facility": "3615",
  "West Virginia - Gilmer FCI": "1668",
  "West Virginia - Hazelton FCC": "1644",
  "West Virginia - Huttonsville Correctional Center": "1942",
  "West Virginia - Lakin Correctional Center for Women": "2062",
  "West Virginia - McDowell County Correctional Center": "2224",
  "West Virginia - McDowell FCI": "1677",
  "West Virginia - Morgantown FPC": "1686",
  "West Virginia - Mount Olive Correctional Complex": "2325",
  "West Virginia - Northern Regional  Jail and Correctional Center": "2392",
  "West Virginia - Ohio County Correctional Complex": "2422",
  "West Virginia - Parkersburg Correctional Center": "3388",
  "West Virginia - Pruntytown Correctional Center": "2534",
  "West Virginia - Saint Mary's Correctional Center": "2638",
  "West Virginia - Salem Correctional Center": "2640",
  "West Virginia - Stevens Correctional Center": "2776",
  "Wyoming - Casper Residential Re-Entry Center": "2572",
  "Wyoming - Wyoming Honor Conservation/Boot Camp": "3017",
  "Wyoming - Wyoming Honor Farm": "3018",
  "Wyoming - Wyoming Medium Correctional Institution": "3019",
  "Wyoming - Wyoming State Penitentiary": "3020",
  "Wyoming - Wyoming Women's Center": "3021"
};


// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { PRISON_DATA };
} else if (typeof window !== 'undefined') {
  window.PRISON_DATA = PRISON_DATA;
}
